import { render, staticRenderFns } from "./AuctionTypeSelect.vue?vue&type=template&id=951ad534&scoped=true&"
import script from "./AuctionTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./AuctionTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951ad534",
  null
  
)

export default component.exports